__turbopack_context__.v({
  "JSONPrettyPrintMain": "JSONPrettyPrint-module__saubKq__JSONPrettyPrintMain",
  "boolean": "JSONPrettyPrint-module__saubKq__boolean",
  "key": "JSONPrettyPrint-module__saubKq__key",
  "null": "JSONPrettyPrint-module__saubKq__null",
  "number": "JSONPrettyPrint-module__saubKq__number",
  "string": "JSONPrettyPrint-module__saubKq__string",
});
